(function() { window.GUID_4c52c4e0_0ddf_4f50_b9df_8a0375818224 = { getGuid: function() { return "4c52c4e0-0ddf-4f50-b9df-8a0375818224"; } }; })();
var CS;
(function (CS) {
    class Point {
        constructor(point) {
            if (point != null) {
                this.X = point.X;
                this.Y = point.Y;
            }
        }
        static FromJQueryCoordinates(position) {
            return new Point({ X: position.left, Y: position.top });
        }
        ToJQueryCoordinates() {
            return { left: this.X, top: this.Y };
        }
    }
    CS.Point = Point;
    class Layout {
        constructor($element, $parent) {
            let element = $element[0];
            let parent = $parent[0];
            let itemWidth = $element.outerWidth();
            let itemHeight = $element.outerHeight();
            let itemTop = element.offsetTop - parent.offsetTop;
            if ($parent.css("position") === "fixed") {
                itemTop = element.offsetTop - parent.clientTop;
            }
            let itemBottom = itemTop + itemHeight;
            this.Left = null;
            this.Top = itemTop;
            this.Bottom = itemBottom;
            this.Right = null;
            this.ScrolledTop = itemTop - parent.scrollTop;
            this.ScrolledBottom = itemBottom - parent.scrollTop;
            this.ScrolledLeft = null;
            this.ScrolledRight = null;
            this.Size = new Size(itemWidth, itemHeight);
        }
    }
    CS.Layout = Layout;
    class Size {
        get Ratio() {
            return this.Width / this.Height;
        }
        constructor(width, height) {
            this.Width = width;
            this.Height = height;
        }
    }
    CS.Size = Size;
})(CS || (CS = {}));

//# sourceMappingURL=cs-ui.js.map
